<template>
  <base-box>
    <div class="header">
      <div class="status">
        <base-badge
          :type="getType(domain)"
          :name="getName(domain)"
          :absolute="false"
        />
        <!-- <p>{{ getStatus(domain) }}</p> -->
      </div>

      <div class="buttons">
        <base-button
          design="four-mini"
          v-if="domain.status === DomainStatus.OPENED"
          title="Configurar"
          @click="onShowConfiguration(domain)"
        >
          <i class="fal fa-cog" />
        </base-button>
        <base-button
          v-if="[DomainStatus.OPENED, DomainStatus.ERROR].indexOf(domain.status) == -1"
          design="four-mini"
          @click="toggleAsFavorite(domain.url)"
          :title="`${
            domain.url !== mainUrl
              ? 'Marcar como principal'
              : 'Domínio principal'
          }`"
        >
          <i
            :class="`${domain.url === mainUrl ? 'fas' : 'fal'} fa-star`"
            :style="`color: ${domain.url === mainUrl ? '#FFCC99' : '#aaaaab'}`"
          />
        </base-button>
        <base-button v-if="domain.status === 1" design="four-mini">
          <i class="far fa-redo-alt" />
        </base-button>
        <base-button
          design="four-mini"
          @click="removeDomain(domain.url)"
          title="Remover domínio"
        >
          <i class="far fa-trash-alt" />
        </base-button>
      </div>
    </div>
    <div class="url-1">
      <p>{{ domain.url }}</p>
      <i
        v-if="domain.copy !== true"
        class="fal fa-copy"
        @click="
          copyToClipboard(`https://${domain.url}`, index);
          domain.copy = !domain.copy;
        "
        title="Copiar"
      />
      <base-badge v-else type="success" name="Copiado" :absolute="false" />
    </div>
  </base-box>
</template>
<script>
import { mapState } from 'vuex';
import AppBridge from '@/plugins/app';
import BaseTitle from '@/components/Title';
import BaseEmpty from '@/components/Empty';
import BaseBox from '@/components/Box';
import BaseBadge from '@/components/Badge';
import BaseButton from '@/components/Button';
import BaseInput from '@/components/Input';
import BaseAdd from '@/components/Add';
import BaseDrawer from '@/components/Drawer';
import BaseLabel from '@/components/Label';
import BaseCard from '@/components/Card';
import BaseSteps from '@/components/Steps';
import dayjs, { Dayjs } from 'dayjs';
import { DomainStatus } from '@/api/domain';

const components = {
  BaseTitle,
  BaseEmpty,
  BaseBox,
  BaseBadge,
  BaseButton,
  BaseInput,
  BaseAdd,
  BaseDrawer,
  BaseLabel,
  BaseCard,
  BaseSteps,
};

export default {
  components,
  props: {
    domain: { type: Object, default: {} },
  },
  data() {
    return {
      DomainStatus,
    };
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.store.isMobile,
      mainUrl: (state) => state.store.configurations.mainUrl,
    }),
  },
  methods: {
    toggleAsFavorite(url) {
      if (url != this.mainUrl) {
        this.$emit('toggleFavorite', url);
      }
    },
    removeDomain(domainUrl) {
      this.$emit('domainDelete', domainUrl);
    },
    onShowConfiguration(domain) {
      this.$emit('showConfigurations', domain);
    },
    getType({ status, expirationDate }) {
      let result = '';
      switch (status) {
        case DomainStatus.OPENED:
          result = 'neutral';
          break;
        case DomainStatus.CONFIGURED:
          // const currentDate = dayjs(new Date());
          // const next30Days = dayjs(currentDate).add(30, 'day');
          // if ( expirationDate && 
          //   (dayjs(expirationDate).isBefore(currentDate) ||
          //   dayjs(expirationDate).isBefore(next30Days))
          // ) {
          //   result = 'exclamation';
          // } else {
            result = 'success';
          // }
          break;
        case DomainStatus.ERROR:
          result = 'danger';
          break;
        default:
          result = 'danger';
          break;
      }

      return result;
    },
    getName({ status, expirationDate }) {
      let result = '';
      switch (status) {
        case DomainStatus.OPENED:
          result = 'Em ativação';
          break;
        case DomainStatus.CONFIGURED:
          // const currentDate = dayjs(new Date());
          // const next30Days = dayjs(currentDate).add(30, 'day');
          // if (expirationDate && dayjs(expirationDate).isBefore(currentDate)) {
          //   result = 'Erro';
          // } else if (expirationDate && dayjs(expirationDate).isBefore(next30Days)) {
            // result = 'Expirará em breve';
          // } else {
            result = 'Ativo';
          // }
          break;
        case DomainStatus.ERROR:
          result = 'Erro';
          break;
        default:
          result = `Status Desconhecido`;
          break;
      }

      return result;
    },
    getStatus({ status, expirationDate }) {
      let result = '';
      switch (status) {
        case DomainStatus.OPENED:
          result = 'Configuração em andamento';
          break;
        case DomainStatus.CONFIGURED:
        case DomainStatus.ERROR:
          result = null;
          // const expirationDay = dayjs(expirationDate);
          // result = `Expira em ${expirationDay.format('DD/MM/YYYY')}`;
          break;
        default:
          result = null;
          // result = `Expiração desconhecida`;
          break;
      }

      return result;
    },
    copyToClipboard(url, id) {
      if (!AppBridge.isApp()) navigator.clipboard.writeText(url);
      else {
        AppBridge.emit('copyStoreLink', url);
      }

      if (id === 'config-1') {
        this.copyUrl1 = true;
      }

      setTimeout(() => {
        this.domains[id].copy = !this.domains[id].copy;
        this.copyLink = false;
      }, 5000);
    },
  },
};
</script>

<style scoped>
.grid {
  display: grid;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.grid > div {
  margin-bottom: 0;
}
.grid > .add-box {
  height: 180px;
}
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-bottom: 15px;
  margin-bottom: 25px;
  border-bottom: 1px solid #99999926;
}
.status {
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
}
.input-copy {
  position: relative;
}
.input-copy .copy {
  position: absolute;
  bottom: 6px;
  right: 15px;
  cursor: pointer;
  height: 36px;
  display: flex;
  align-items: center;
}
.input-copy .copy i {
  color: var(--icon-inactive);
  font-size: 17px;
}
.copy-code {
  color: var(--label-secondary);
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 10px;
  text-align: center;
  font-weight: bold;
}
.link-instructions {
  color: #aaaaab80;
  font-size: 12px;
  line-height: 15px;
  left: 15px;
  text-align: center;
}
.link-instructions a {
  color: #aaaaab80;
  font-weight: 900;
  border-bottom: 1px solid transparent;
  padding-bottom: 2px;
  text-decoration: none;
}
.link-instructions a:hover {
  color: var(--label-secondary);
  border-color: var(--label-secondary);
}
.url-config {
  color: #aaaaabbf;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 5px;
  text-align: center;
  font-weight: bold;
}
.timer {
  background: #45484d80;
  border-radius: 5px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
}
.timer p {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
  margin-left: 10px;
}
.timer i {
  font-size: 14px;
  color: var(--icon-inactive);
}
.status p {
  font-size: 14px;
  color: #cccccc;
  margin-top: 15px;
}
.buttons {
  display: flex;
}
.buttons button:not(:last-child) {
  margin-right: 15px;
}
.url-1,
.url-2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 20px;
  min-height: 45px;
  border-radius: 5px;
}
.url-1 {
  background: transparent;
  border: 1px solid #515159;
}
.url-2 {
  background: var(--box-up);
}
.url-1 p,
.url-2 p {
  color: var(--label-primary);
  font-size: 12px;
}
.url-1 i,
.url-2 i {
  color: var(--icon-inactive);
  font-size: 17px;
  cursor: pointer;
}

.hairline {
  margin: 30px auto;
  border-top: 1px solid #ffffff17;
  width: 100%;
}

.read-instructions {
  padding: 30px 20px 20px;
  background: #3f4145;
  border: 2px dashed #ffffff17;
}

.read-instructions p.title {
  color: var(--label-secondary);
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 20px;
  font-weight: bold;
  text-align: center;
}

.read-instructions p.description {
  font-size: 14px;
  color: var(--label-primary);
  line-height: 22px;
  text-align: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.read-instructions p.description span {
  color: var(--default);
  font-weight: 900;
}

@media screen and (max-width: 991px) {
  .grid {
    grid-template-columns: repeat(1, 1fr);
  }
  .status p {
    font-size: 10px;
  }
  .grid > .add-box {
    height: auto;
  }
}
</style>
